import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  Chip,
} from "@mui/material";
import HeadingCard from "../../newComponent/NewCardsComp/HeadingCard";
import { Style } from "@mui/icons-material";
import StyledTableContainer from "../../newComponent/TableContainer";
import { useParams } from "react-router-dom";
import { getPackgeDetailsById } from "./services/fetchPackgesById";
import LoaderComp from "../../newComponent/LoaderComp/Loader";
import AllBranches from "../Campaign/AllBranches";
import CustomPopup from "../../../components/CustomPopup";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function TestPackageViewDetails({}) {
  const { id } = useParams();

  const [data, setData] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [openBranchPopup, setOpenBranchPopup] = useState(false);
  const [title, setTitle] = useState("");
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response = await getPackgeDetailsById(id);
        setData(response);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  // ================= DETAIL CARD =================
  const DetailCard = ({ title, value }) => (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 3,
        background: "#fff",
        borderLeft: "5px solid #66BB6A",
        boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
      }}
    >
      <Typography variant="subtitle1" color="text.secondary">
        {title}
      </Typography>

      <Typography variant="h4" fontWeight={600} mt={0.5}>
        {value || "-"}
      </Typography>
    </Paper>
  );

  // ================= SECTION TABLE =================
  const SectionTable = ({ title, prefix }) => (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        background: "#fff",
        boxShadow: "0px 4px 25px rgba(0,0,0,0.08)",
        mb: 3,
      }}
    >
      <Typography variant="h4" fontWeight={600}>
        {title}
      </Typography>

      <Divider sx={{ my: 2 }} />

      <StyledTableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow sx={{ background: "#66BB6A" }}>
              <TableCell sx={{ color: "#fff" }}>Reading</TableCell>
              <TableCell sx={{ color: "#fff" }}>Listening</TableCell>
              <TableCell sx={{ color: "#fff" }}>Writing</TableCell>
              <TableCell sx={{ color: "#fff" }}>Speaking</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>{data?.[`${prefix}_reading`] || 0}</TableCell>
              <TableCell>{data?.[`${prefix}_listening`] || 0}</TableCell>
              <TableCell>{data?.[`${prefix}_writing`] || 0}</TableCell>
              <TableCell>{data?.[`${prefix}_speaking`] || 0}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </Paper>
  );

  return (
    <>
      <LoaderComp isLoading={loading} />
      <Box
        sx={{
          minHeight: "100vh",
        }}
      >
        {/* ================= TITLE ================= */}
        <HeadingCard label={data?.package_name} />

        {/* ================= BASIC DETAILS ================= */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            mt: 3,
            borderRadius: 3,
            background: "#fff",
            boxShadow: "0px 4px 25px rgba(0,0,0,0.08)",
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h3">Basic Details</Typography>
              <Divider sx={{ my: 2 }} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <DetailCard
                title="Service"
                value={data?.service_id?.service_name}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <DetailCard title="Test Type" value={data?.test_type?.name} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <DetailCard
                title="Sub Test Type"
                value={data?.sub_test_type_id?.name}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: 3,
                  background: "#fff",
                  borderLeft: "5px solid #66BB6A",
                  boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
                }}
              >
                <Typography variant="subtitle2" color="text.secondary" mb={1}>
                  Sub Service
                </Typography>

                <Stack
                  direction="row"
                  spacing={1}
                  flexWrap="wrap"
                  sx={{ rowGap: 1.5 }}
                >
                  {data?.sub_service_id?.slice(0, 2).map((item, index) => (
                    <Chip
                      key={index}
                      label={item}
                      size="small"
                      sx={{
                        backgroundColor: "#E8F5E9",
                        color: "#2E7D32",
                        fontWeight: 500,
                      }}
                    />
                  ))}

                  {data?.sub_service_id?.length > 2 && (
                    <Chip
                      label={`+${data.sub_service_id.length - 2} More`}
                      size="small"
                      clickable
                      onClick={() => {
                        setOpenBranchPopup(true);
                        setTitle("Sub Service");
                        setSelectedData(data?.sub_service_id);
                      }}
                      sx={{
                        backgroundColor: "#E3F2FD",
                        color: "#1565C0",
                        fontWeight: 600,
                        cursor: "pointer",
                      }}
                    />
                  )}
                </Stack>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <DetailCard title="Duration(Session)" value={data?.duration} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <DetailCard
                title="Country"
                value={data?.country_id?.country_name}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <DetailCard title="Currency" value={data?.currency} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: 3,
                  background: "#fff",
                  borderLeft: "5px solid #66BB6A",
                  boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
                }}
              >
                <Typography variant="subtitle2" color="text.secondary" mb={1}>
                  Branch
                </Typography>

                <Stack
                  direction="row"
                  spacing={1}
                  flexWrap="wrap"
                  sx={{ rowGap: 1.5 }}
                >
                  {data?.branch_id?.slice(0, 2).map((item, index) => (
                    <Chip
                      key={index}
                      label={item}
                      size="small"
                      sx={{
                        backgroundColor: "#E8F5E9",
                        color: "#2E7D32",
                        fontWeight: 500,
                      }}
                    />
                  ))}

                  {data?.branch_id?.length > 2 && (
                    <Chip
                      label={`+${data.branch_id.length - 2} More`}
                      size="small"
                      clickable
                      onClick={() => {
                        setOpenBranchPopup(true);
                        setTitle("Branch");
                        setSelectedData(data?.branch_id);
                      }}
                      sx={{
                        backgroundColor: "#E3F2FD",
                        color: "#1565C0",
                        fontWeight: 600,
                        cursor: "pointer",
                      }}
                    />
                  )}

                  {data?.branch_id?.length === 0 && (
                    <Typography variant="h4" fontWeight={600} mt={0.5}>
                      {"-"}
                    </Typography>
                  )}
                </Stack>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <DetailCard title="original price" value={data?.original_price} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <DetailCard
                title="Discounted Price"
                value={data?.discounted_price}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <DetailCard
                title="Installments"
                value={data?.payable_installment}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <DetailCard
                title="Is Testiva Package"
                value={data?.is_testiva_map === 1 ? "Yes" : "No"}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <DetailCard
                title="Testiva Package"
                value={data?.testiva_package_id?.name}
              />
            </Grid>
          </Grid>
        </Paper>

        {/* ================= MOCK ================= */}
        {/* <SectionTable title="Mock Tests" prefix="mock" /> */}
      </Box>

      <CustomPopup
        open={openBranchPopup}
        onClose={() => setOpenBranchPopup(false)}
        component={
          <AllBranches
            onClose={() => setOpenBranchPopup(false)}
            selectedbranhes={selectedData}
          />
        }
        title={title}
        showDivider="true"
        maxWidth="xs"
      />
    </>
  );
}
